module.exports = __webpack_public_path__ + "img/home-logo_tc.523976f9.png";